module.exports = __webpack_public_path__ + "img/easter_tour_mini_cover_2.706d1548.png";